import React, { useEffect, useState } from 'react'
import ICImage from '../../core-component/ICImage'
import UseTranslationHook from '../../hooks/UseTranslationHook'
import { addressIcon, emailIcon, phoneCallIcon, whiteClockIcon, xIcon } from '../../assets/icons/SvgIconList'
import { IContact, IElement, contactValidationSchema, getContactInitialValue, handleSubmitContact } from './ContactUsViewController'
import { fetchContactDetails } from './ContactUsViewController'
import { APP_CONTENT_TYPE, CONTACT_US_TYPE, PUBLIC_HEADER_TABS, PUBLIC_TABS } from '../../utils/AppEnumerations'
import ICTextInput from '../../core-component/ICTextInput'
import { Form, Formik } from 'formik'
import ICTextArea from '../../core-component/ICTextArea'
import ICButton from '../../core-component/ICButton'
import CopyrightFooter from '../../components/common/CopyrightFooter'
import { Link } from 'react-router-dom'
import { publicRoute } from '../../routes/RoutePublic'
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import PublicHeader from '../public-header/PublicHeader'
import Loader from '../../components/common/Loader'
import { GoogleReCaptchaProvider, GoogleReCaptcha } from "react-google-recaptcha-v3";
gsap.registerPlugin(ScrollTrigger);


const ContactUsView = () => {
    const { t } = UseTranslationHook();
    const [contactFormInitialValues, setContactFormInitialValues] =
        useState<IContact>();
    const [contactUs, setContactUs] = useState<IElement[]>([]);
    const [loading, setLoading] = useState(false);
    const [publicLoader, setPublicLoader] = useState(true);
    const [token, setToken] = useState("");
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    let timer: NodeJS.Timeout;

    useEffect(() => {
        document.title = PUBLIC_TABS.ContactUs;
        fetchContactDetails(setContactUs, APP_CONTENT_TYPE.VPContact)
        setTimeout(async () => {
            setPublicLoader(false)
        }, 2000);
        setContactFormInitialValues(getContactInitialValue)
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [])
    useEffect(() => {
        setTimeout(async () => {
            gsap.to(`.contact-banner`, {
                scrollTrigger: {
                    trigger: ".contact-section",
                },
                opacity: 1,
                scale: 2,
                ease: "power2.out",
                duration: 2,
            })
            gsap.to(`.contact-us-section`, {
                opacity: 1,
                yPercent: '40',
                ease: "power2.out",
                duration: 2,
            })
            gsap.to(`.contact-us-head`, {
                opacity: 1,
                yPercent: '120',
                ease: "power2.out",
                duration: 2,
            })
        }, 2000);
    })
    const sentence = t('sentence');
    const speed = 30;

    const handleSubmitContactDetails = async (values: IContact) => {
        await handleSubmitContact(values, setLoading)
    }
    return (
        <div className='bg-skin-home-bg'>
            {loading || publicLoader ? (<div className="h-screen flex items-center flex-col bg-black">
                <Loader />
            </div>) : (<>
                <div className='h-24'> <PublicHeader activeTab={PUBLIC_HEADER_TABS.ContactUs} /></div>
                <div>
                    <div className='contact-us-head'>
                        <h1 className='lg:text-7xl text-5xl text-skin-home-text'>{t("get_in_touch")}</h1>
                    </div>
                </div>
                <section className='flex flex-col h-[15rem] mt-3 justify-center items-center p-3'>
                    <div className='text-skin-home-text  lg:text-4xl text-xl text-center'>{t("any_question")}</div>
                </section>
                <section className='flex justify-center scale-50 contact-section '>
                    <div className='bg-skin-home-slide contact-us-box contact-banner grid grid-cols-12 container xl:w-2/3 p-3 opacity-0'>
                        <div className='xl:col-span-5 col-span-12 rounded-lg h-full bg-skin-about-banner'>
                            <div className='p-5 flex flex-col h-full'>
                                <div>
                                    <h1 className='text-4xl text-skin-home-text'>{t("get_in_touch")}</h1>
                                    <p className='text-xl top text-skin-home-text'>{t("fill_form")}</p>
                                </div>
                                <div className='mt-5 gap-4 flex flex-col h-full justify-between'>
                                    {contactUs && contactUs.length > 0 && contactUs.map((item, index) => (
                                        <>
                                            <div className='grid mt-6 grid-cols-1'>
                                                <div className='flex'>
                                                    <div className='w-6 h-6 mr-3'>
                                                        {item.type === CONTACT_US_TYPE.contact_number ? phoneCallIcon : item.type === CONTACT_US_TYPE.email_address ? emailIcon : addressIcon}
                                                    </div>
                                                    <div className='w-full'>  <a href={item.type === CONTACT_US_TYPE.contact_number ? "tel:+91 99253-41-603" : item.type === CONTACT_US_TYPE.email_address ? "mailto:email@company.com" : "#"}> <span className='text-skin-home-text'>{item.value}</span></a></div>
                                                </div>
                                            </div>
                                            {index == 1 &&
                                                <div className='grid mt-6 grid-cols-1'>
                                                    <div className='flex'>
                                                        <div className='w-6 h-6 mr-3'>
                                                            {whiteClockIcon}
                                                        </div>
                                                        <div className='w-full'> <span className='text-skin-home-text'>{t("timings")}</span></div>
                                                    </div>
                                                </div>
                                            }
                                            {index == 2 &&
                                                <div className='grid mt-6 grid-cols-1'>
                                                    <div className=" social-menu flex flex-col h-full">
                                                        <ul className='h-full'>
                                                            <li><Link to="https://www.instagram.com/vprosper_official/" target="blank"><i className="fab fa-instagram"></i></Link></li>
                                                            <li><Link to="https://www.linkedin.com/in/v-prosper-920333312/" target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                                                            <li>
                                                                <Link to="https://x.com/vprosper_in/" target="_blank" className='flex justify-center items-center w-full h-full'>
                                                                    <div className='p-4 w-full h-7'>
                                                                        {xIcon}
                                                                    </div>
                                                                </Link>
                                                            </li>
                                                            <li><Link to="https://www.facebook.com/profile.php?id=61560278146286" target='blank'><i className="fab fa-facebook"></i></Link></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='xl:col-span-7 col-span-12 m-5'>
                            {contactFormInitialValues && (
                                <Formik
                                    initialValues={contactFormInitialValues}
                                    validationSchema={() => contactValidationSchema(t)}
                                    onSubmit={(values) => handleSubmitContactDetails(values)}
                                >
                                    {(formikPorps) => {
                                        const { handleSubmit, values, errors, submitCount } =
                                            formikPorps;
                                        return (
                                            <Form
                                                onSubmit={handleSubmit}
                                                className="flex flex-row h-full w-full"
                                            >
                                                <div className="overflow-y-auto w-full pt-2.5">
                                                    <div className='flex w-full'>
                                                        <div className="mr-5 w-full">
                                                            <label htmlFor="">{t("first_name")}*</label>
                                                            <ICTextInput
                                                                name={"first_name"}
                                                                value={formikPorps.values.first_name}
                                                                placeholder={t("first_name")}
                                                                onChange={formikPorps.handleChange}
                                                                onBlur={formikPorps.handleBlur}
                                                                errorMessage={
                                                                    formikPorps.touched.first_name &&
                                                                        formikPorps.errors.first_name
                                                                        ? formikPorps.errors.first_name
                                                                        : undefined
                                                                }
                                                                className='contact-inputs w-full'
                                                            />
                                                        </div>
                                                        <div className='w-full'>
                                                            <label htmlFor="">{t("last_name")}*</label>

                                                            <ICTextInput
                                                                name={"last_name"}
                                                                value={formikPorps.values.last_name}
                                                                placeholder={t("last_name")}
                                                                onChange={formikPorps.handleChange}
                                                                onBlur={formikPorps.handleBlur}
                                                                errorMessage={
                                                                    formikPorps.touched.last_name &&
                                                                        formikPorps.errors.last_name
                                                                        ? formikPorps.errors.last_name
                                                                        : undefined
                                                                }
                                                                className='contact-inputs w-full'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='top w-full'>
                                                        <label htmlFor="">{t("mobile_number")}</label>
                                                        <ICTextInput
                                                            type='number'
                                                            name={"contact_number"}
                                                            value={formikPorps.values.contact_number}
                                                            placeholder={t("mobile_number")}
                                                            onChange={formikPorps.handleChange}
                                                            onBlur={formikPorps.handleBlur}
                                                            errorMessage={
                                                                formikPorps.touched.contact_number &&
                                                                    formikPorps.errors.contact_number
                                                                    ? formikPorps.errors.contact_number
                                                                    : undefined
                                                            }
                                                            className='contact-inputs w-full'
                                                        />
                                                    </div>
                                                    <div className='top w-full'>
                                                        <label htmlFor="">{t("email")}*</label>
                                                        <ICTextInput
                                                            name={"contact_email_address"}
                                                            value={formikPorps.values.contact_email_address}
                                                            placeholder={t("email")}
                                                            onChange={formikPorps.handleChange}
                                                            onBlur={formikPorps.handleBlur}
                                                            errorMessage={
                                                                formikPorps.touched.contact_email_address &&
                                                                    formikPorps.errors.contact_email_address
                                                                    ? formikPorps.errors.contact_email_address
                                                                    : undefined
                                                            }
                                                            className='contact-inputs w-full'
                                                        />
                                                    </div>
                                                    <div className='top w-full'>
                                                        <label htmlFor="">{t("subject")}*</label>
                                                        <ICTextInput
                                                            name={"inquiry_subject"}
                                                            value={formikPorps.values.inquiry_subject}
                                                            placeholder={t("subject")}
                                                            onChange={formikPorps.handleChange}
                                                            onBlur={formikPorps.handleBlur}
                                                            errorMessage={
                                                                formikPorps.touched.inquiry_subject &&
                                                                    formikPorps.errors.inquiry_subject
                                                                    ? formikPorps.errors.inquiry_subject
                                                                    : undefined
                                                            }
                                                            className='contact-inputs w-full'
                                                        />
                                                    </div>
                                                    <div className='top w-full'>
                                                        <label htmlFor="">{t("message")}*</label>
                                                        <ICTextArea
                                                            name={"message_content"}
                                                            value={formikPorps.values.message_content}
                                                            placeholder={t("message")}
                                                            onChange={formikPorps.handleChange}
                                                            onBlur={formikPorps.handleBlur}
                                                            errorMessage={
                                                                formikPorps.touched.message_content &&
                                                                    formikPorps.errors.message_content
                                                                    ? formikPorps.errors.message_content
                                                                    : undefined
                                                            }
                                                            className='contact-inputs w-full'
                                                        />
                                                    </div>
                                                    {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
                                                        <GoogleReCaptcha
                                                            className="google-recaptcha-custom-class"
                                                            onVerify={setTokenFunc}
                                                            refreshReCaptcha={refreshReCaptcha}
                                                        />
                                                    </GoogleReCaptchaProvider> */}
                                                    <div className='top w-full flex justify-center'>
                                                        <ICButton
                                                            type="submit"
                                                            children={t("submit")}
                                                            className="mx-2 !w-2/4 !bg-skin-home-bg"
                                                        />
                                                    </div>
                                                </div>
                                            </Form>
                                        )
                                    }}
                                </Formik>
                            )}
                        </div>
                    </div>
                </section>
                <section className='top'>
                    <h1 className='text-5xl top text-center text-skin-home-text'>{t("locate_us")}</h1>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d147921.1798860512!2d72.49348506511909!3d23.13697038718152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c2920d010b9bf%3A0x45f26c92ff57b5fc!2sNIRMAN%20SATVA!5e0!3m2!1sen!2sin!4v1718807548190!5m2!1sen!2sin" width="600" height="450" className="w-full top h-[30rem]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen></iframe>

                </section>
                <CopyrightFooter /></>)}
        </div>
    )
}

export default ContactUsView
